import React from "react";

import Icon from "shared/components/Icon";
import InfoPage from "shared/templates/InfoPage";

type DealLoadErrorProps = {
  onRetry: () => void;
};

export const DealLoadError = ({ onRetry }: DealLoadErrorProps) => (
  <InfoPage
    title="Unable to Load Deal"
    description="Something went wrong while loading this deal. Please try again."
    MainIcon={Icon.Error500Icon}
    button={{
      children: "Try Again",
      onClick: onRetry,
    }}
    width="900px"
  />
);
